import React from 'react';
import {Skeleton} from '@mui/material';

const SkeletonWrap = props=>{
    let {children, skeleton, variant='rounded'} = props;
    if (!skeleton)
        return children;
    return <Skeleton variant={variant}>{children}</Skeleton>;
};

export default SkeletonWrap;
